import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useSonner } from "sonner";
import { cn } from "@/lib/utils";
import { useThemeConfig } from "@/components/ui/theme-config-provider";

interface AddItemButtonProps {
  onClick: () => void;
  dimmed?: boolean;
}

const AddItemButton = ({ onClick, dimmed = false }: AddItemButtonProps) => {
  const { toasts } = useSonner();
  const hasToast = toasts.length > 0;
  const { theme } = useThemeConfig();
  // Extra space when a toast is present to prevent overlap
  const offset = hasToast ? "7rem" : "2.5rem";

  return (
    <div
      className="fixed right-6 z-[10000] transition-all"
      // Keeps button above system UI using device safe area
      style={{ bottom: `calc(${offset} + var(--safe-area-bottom))` }}
    >
      <Button
        size="lg"
        className={cn(
          "tutorial-target-shoppingheader-additem h-14 w-14 rounded-full shadow-xl border border-white",
          "bg-[var(--btn-bg)] hover:bg-[var(--btn-bg-hover)]",
          "focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-white"
        )}
        style={{
          backgroundColor: theme.primaryColor,
          "--btn-bg": theme.primaryColor,
          "--btn-bg-hover": theme.primaryColor,
          color: theme.textPrimaryColor,
          fontWeight: "bold",
          opacity: dimmed ? 0.3 : 1,
          pointerEvents: dimmed ? "none" : undefined,
        } as React.CSSProperties}
        onClick={onClick}
        aria-label="Aggiungi nuovo articolo"
      >
        <Plus className="h-6 w-6" aria-hidden="true" />
      </Button>
    </div>
  );
};

export default AddItemButton;

